import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Culture } from '../../models/culture';

export const adapter: EntityAdapter<Culture> = createEntityAdapter<Culture>({
  selectId: (culture) => culture.twoLetterISOLanguageCode,
});
